import MultipleUrisField from 'components/ContentReporting/Form/Fields/MultipleUrisField/MultipleUrisField';
import SingleUriField from 'components/ContentReporting/Form/Fields/SingleUriField/SingleUriField';
import { OPTIONS_CONTENT_TYPE } from 'components/ContentReporting/shared-constants';
import { CONTENT_TYPES } from 'components/ContentReporting/content-types';

export const withFullTranslationKey = translationKey => {
  return `infringement_claim_form:${translationKey}`;
};

// This is introduced due to different number of URIs per claim type
// For OPTIONS_CLAIM_TYPE.OTHER there's a 10 URI limit
export const MAXIMUM_NUMBER_URIS_NON_IP = 10;
// For non OPTIONS_CLAIM_TYPE.OTHER claim type, there's a 200 URI limit
export const MAXIMUM_NUMBER_URIS = 200;

export const CLAIMANT_DETAILS = {
  fields: {
    CLAIMANT_FIRST_NAME: 'claimantFirstName',
    CLAIMANT_LAST_NAME: 'claimantLastName',
    CLAIMANT_PASSPORT_NUMBER: 'claimantPassportNumber',
    CLAIMANT_PASSPORT_AUTHORITY: 'claimantPassportAuthority',
    CLAIMANT_PASSPORT_ISSUED_DATE: 'claimantPassportIssuedDate',
    CLAIMANT_COMPANY_NAME: 'claimantCompanyName',
    CLAIMANT_ADDRESS: 'claimantAddress',
    CLAIMANT_PHONE: 'claimantPhone',
    CLAIMANT_EMAIL: 'claimantEmail',
    CLAIMANT_MORE_INFO: 'claimantMoreInfo',
    CLAIMANT_COUNTRY_CODE: 'claimantCountryCode',
  },
  labels: {
    CLAIMANT_FIRST_NAME: 'claimant_first_name_label',
    CLAIMANT_LAST_NAME: 'claimant_last_name_label',
    CLAIMANT_FIRST_NAME_PATRONYMIC: 'claimant_first_name_patronymic_label',
    CLAIMANT_PASSPORT_NUMBER: 'claimant_passport_number_label',
    CLAIMANT_PASSPORT_AUTHORITY: 'claimant_passport_authority_label',
    CLAIMANT_PASSPORT_ISSUED_DATE: 'claimant_passport_issued_date_label',
    CLAIMANT_COMPANY_NAME: 'claimant_company_name_label',
    CLAIMANT_ADDRESS: 'claimant_address_label',
    CLAIMANT_EMAIL: 'claimant_email_label',
    CLAIMANT_PHONE: 'claimant_phone_label',
    CLAIMANT_MORE_INFO: 'claimant_more_info_label',
  },
};

export const CONTENT_DETAILS = {
  fields: {
    REPORTED_CONTENT_URIS: 'productUris',
    REPORTED_CONTENT_TYPE: 'contentType',
    REPORTED_CONTENT_DESCRIPTION: 'contentDescription',
    CLAIM_TYPE: 'claimType',
    ASSOCIATED_CONTENT: 'associatedContent',
  },
  labels: {
    REPORTED_CONTENT_URIS: 'content_uris_label',
    REPORTED_CONTENT_ONE_URI: 'content_one_uri_label',
    REPORTED_CONTENT_DESCRIPTION: 'case_description_label',
    REPORTED_CONTENT_DESCRIPTION_NON_IP: 'case_description_label_non_ip',
  },
  translationPrefixes: {
    REPORTED_CONTENT_TYPE: 'content_type',
    CLAIM_TYPE: 'claim_type',
  },
};

export const CLAIM_DETAILS = {
  fields: {
    CLAIMANT_RELATIONSHIP_RIGHTSHOLDER: 'relationshipWithRightsholder',
    RIGHTSHOLDER_NAME: 'rightsholderName',
    RIGHTSHOLDER_PHONE_FAX: 'rightsholderPhoneFax',
    RIGHTSHOLDER_EMAIL: 'rightsholderEmail',
    RIGHTSHOLDER_ROLE: 'claimantRelationshipDetailed',
    CLAIM_COPYRIGHT: 'copyrightType',
    CLAIM_COPYRIGHT_INFO: 'copyrightDescription',
    CLAIM_TERRITORIES: 'territories',
    CLAIM_OTHER_TERRITORIES: 'otherTerritories',
    CLAIM_OTHER: 'claimTypeOther',
    CLAIM_TRADEMARK_NO: 'trademarkRegistrationNumbers',
    CLAIM_TRADEMARK_STATUS: 'trademarkStatus',
  },
  labels: {
    RIGHTSHOLDER_NAME: 'rightsholder_name',
    RIGHTSHOLDER_PHONE_FAX: 'rightsholder_phone_fax',
    RIGHTSHOLDER_EMAIL: 'rightsholder_email',
    RIGHTSHOLDER_ROLE_INPUT_LABEL: 'rightsholder_role_input_label',
    CLAIM_COPYRIGHT_INFO: 'claim_type_copyright_info',
    CLAIM_COPYRIGHT_INFO_UMG: 'claim_type_copyright_info_umg',
    CLAIM_TERRITORIES: 'territories',
    CLAIM_OTHER_TERRITORIES: 'other_territories',
    CLAIM_OTHER_PREFIX: 'claim_type_other',
    CLAIM_TRADEMARK_NO: 'trademark_no',
  },
  translationPrefixes: {
    CLAIM_COPYRIGHT: 'claim_type_copyright',
    CLAIM_TRADEMARK_STATUS: 'trademark_status',
    CLAIMANT_RELATIONSHIP_RIGHTSHOLDER: 'your_relationship_with_rightsholder',
    RIGHTSHOLDER_ROLE: 'rightsholder_role', // Custom prefix, since otherwise the option "label" is in conflict with the label of the select input.
  },
};

export const CONFIRMATION_DETAILS = {
  fields: {
    VERIFICATION_CODE: 'verificationCode',
    LEGAL_OWNER: 'legalCheckboxOwner',
    LEGAL_BELIEF: 'legalCheckboxBelief',
    LEGAL_ACCURATE: 'legalCheckboxAccurate',
    LEGAL_CONTACT: 'legalCheckboxContact',
    LEGAL_MISUSE: 'legalCheckboxMisuse',
    LEGAL_PRIVACY_POLICY: 'legalCheckboxPrivacyPolicy',
    LEGAL_OTHER_VIOLATES: 'legalCheckboxViolates',
    LEGAL_UMG: 'legalCheckboxUmg',
    LEGAL_PERSONAL_IMAGE_REPRESENT: 'personalImageCheckboxRepresent',
    LEGAL_PERSONAL_IMAGE_FORWARDED: 'personalImageCheckboxForwarded',
    LEGAL_PERSONAL_IMAGE_ABUSE: 'personalImageCheckboxAbuse',
  },
  labels: {
    VERIFICATION_CODE: 'verification_code_label',
    LEGAL_OWNER_LABEL: 'legal_checkbox_owner',
    LEGAL_BELIEF_LABEL: 'legal_checkbox_belief',
    LEGAL_ACCURATE_LABEL: 'legal_checkbox_accurate',
    LEGAL_CONTACT_LABEL: 'legal_checkbox_contact',
    LEGAL_MISUSE_LABEL: 'legal_checkbox_misuse',
    LEGAL_PRIVACY_POLICY_LABEL: 'legal_checkbox_privacy_policy',
    LEGAL_OTHER_VIOLATES_LABEL: 'legal_checkbox_violates',
    LEGAL_UMG_LABEL: 'legal_checkbox_umg',
    LEGAL_PERSONAL_IMAGE_REPRESENT_LABEL: 'legal_personal_image_represent',
    LEGAL_PERSONAL_IMAGE_FORWARDED_LABEL: 'legal_personal_image_forwarded',
    LEGAL_PERSONAL_IMAGE_ABUSE_LABEL: 'legal_personal_image_abuse',
  },
};

export const OPTIONS_CLAIM_COPYRIGHT_TYPE = {
  SOUND_RECORDINGS: 'sound_recordings',
  COMPOSITION: 'composition',
  IMAGE: 'image',
  TEXT: 'text',
  VIDEO: 'video',
};

export const OPTIONS_CLAIM_COPYRIGHT_TYPE_LIST = Object.values(OPTIONS_CLAIM_COPYRIGHT_TYPE);

export const OPTIONS_TRADEMARK_STATUS_LIST = ['registered', 'unregistered', 'unregistered_pending'];

export const OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER = {
  SELF: 'rightsholder',
  OTHER: 'authorized_agent',
};

export const OPTIONS_RIGHTSHOLDER_ROLE = {
  OTHER: 'other',
  MANAGER: 'manager',
  LABEL: 'label',
  PUBLISHER: 'publisher',
  ATTORNEY: 'attorney',
  COLLECTING_SOCIETY: 'collecting_society',
  DISTRIBUTOR: 'distributor',
};

export const OPTIONS_RIGHTSHOLDER_ROLE_LIST = Object.values(OPTIONS_RIGHTSHOLDER_ROLE);

export const OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER_LIST = Object.values(
  OPTIONS_CLAIMANT_RELATIONSHIP_RIGHTSHOLDER,
);

export const OPTIONS_CLAIM_TYPE = {
  COPYRIGHT: 'copyright',
  TRADEMARK: 'trademark',
  PERSONAL: 'personal_image',
  OTHER: 'other',
};
export const OPTIONS_CLAIM_TYPE_LIST = Object.values(OPTIONS_CLAIM_TYPE);

export const OPTIONS_CONTENT_TYPE_LIST = Object.values(OPTIONS_CONTENT_TYPE);

export const COPYRIGHT_TYPE_REQUIRED_CONTENT_TYPES = [
  OPTIONS_CONTENT_TYPE.MUSIC,
  OPTIONS_CONTENT_TYPE.PODCAST,
  OPTIONS_CONTENT_TYPE.AUDIOBOOK,
  OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_AUDIO,
];

const getMusicURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.TRACK, CONTENT_TYPES.ALBUM],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getPodcastURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getArtworkURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.TRACK, CONTENT_TYPES.ALBUM, CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getUserURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.USER],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getArtistURIField = _ => {
  return {
    component: SingleUriField,
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI),
    errorMessageKey: withFullTranslationKey('uri_invalid_artist'),
  };
};

const getPlaylistURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.PLAYLIST, CONTENT_TYPES.PLAYLIST_OLD],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getCanvasURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.TRACK],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getClipsURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.ARTIST_VIDEO],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getPollURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.POLL],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getQuestionURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.QUESTION],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getResponseURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [CONTENT_TYPES.RESPONSE],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getUnknownURIField = (maximumNumberOfURI = MAXIMUM_NUMBER_URIS_NON_IP, traw) => {
  return {
    component: MultipleUrisField,
    acceptedUriTypes: [
      CONTENT_TYPES.TRACK,
      CONTENT_TYPES.ALBUM,
      CONTENT_TYPES.SHOW,
      CONTENT_TYPES.EPISODE,
      CONTENT_TYPES.USER,
      CONTENT_TYPES.ARTIST,
      CONTENT_TYPES.PLAYLIST,
      CONTENT_TYPES.PLAYLIST_OLD,
    ],
    labelOverride: withFullTranslationKey(CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS),
    errorMessageKey: traw(withFullTranslationKey('uri_invalid_generic_dynamic_uri_number'), {
      max_uri_number: maximumNumberOfURI,
    }),
    maximumNumberOfURI: maximumNumberOfURI,
  };
};

const getOtherURIField = getUnknownURIField;

export const getClaimTypeURIComponent = (claimType, traw) => {
  switch (claimType) {
    case OPTIONS_CLAIM_TYPE.PERSONAL:
    case OPTIONS_CLAIM_TYPE.COPYRIGHT:
    case OPTIONS_CLAIM_TYPE.TRADEMARK:
      return {
        [OPTIONS_CONTENT_TYPE.MUSIC]: getMusicURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.PODCAST]: getPodcastURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.AUDIOBOOK]: getPodcastURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTWORK]: getArtworkURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.USER_IMAGE]: getUserURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_BIO_TEXT]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_PICK_TEXT]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_PROFILE_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_BANNER_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_GALLERY_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_MERCHANDISE]: getArtistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_DESCRIPTION]: getPlaylistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_IMAGE]: getPlaylistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_TITLE]: getPlaylistURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.NOW_PLAYING]: getCanvasURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_VIDEO]: getClipsURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_TITLE]: getClipsURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_AUDIO]: getClipsURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.POLL_QUESTION_TEXT]: getPollURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.POLL_OPTIONS_TEXT]: getPollURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.QUESTION_TEXT]: getQuestionURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.RESPONSE_TEXT]: getResponseURIField(MAXIMUM_NUMBER_URIS, traw),
        [OPTIONS_CONTENT_TYPE.OTHER]: getOtherURIField(MAXIMUM_NUMBER_URIS, traw),
        UNKNOWN: getUnknownURIField(MAXIMUM_NUMBER_URIS, traw),
      };
    case OPTIONS_CLAIM_TYPE.OTHER:
      return {
        [OPTIONS_CONTENT_TYPE.MUSIC]: getMusicURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.PODCAST]: getPodcastURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.AUDIOBOOK]: getPodcastURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTWORK]: getArtworkURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.USER_IMAGE]: getUserURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_BIO_TEXT]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_PICK_TEXT]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_PROFILE_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_BANNER_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_GALLERY_IMAGE]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_MERCHANDISE]: getArtistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_DESCRIPTION]: getPlaylistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_IMAGE]: getPlaylistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.PLAYLIST_TITLE]: getPlaylistURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.NOW_PLAYING]: getCanvasURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_VIDEO]: getClipsURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_TITLE]: getClipsURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_AUDIO]: getClipsURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.POLL_QUESTION_TEXT]: getPollURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.POLL_OPTIONS_TEXT]: getPollURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.QUESTION_TEXT]: getQuestionURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.RESPONSE_TEXT]: getResponseURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        [OPTIONS_CONTENT_TYPE.OTHER]: getOtherURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
        UNKNOWN: getUnknownURIField(MAXIMUM_NUMBER_URIS_NON_IP, traw),
      };
    default:
      return {};
  }
};

export const TERRITORY_OTHER = 'other';
export const TERRITORY_WORLDWIDE = 'worldwide';
const TERRITORY_UNITED_STATES = 'united_states';
const TERRITORY_EUROPEAN_UNION = 'european_union';

export const TERRITORY_LIST_GENERIC = [TERRITORY_WORLDWIDE, TERRITORY_OTHER];
export const TERRITORY_LIST_TRADEMARK = [TERRITORY_UNITED_STATES, TERRITORY_EUROPEAN_UNION, TERRITORY_OTHER];

export const RUSSIAN_MARKET_LIST = ['ru-ru', 'ru-en'];
